<vw-list-section data-test="weather-moon-band" edge="inset">
  @if (isStale) {
    <!-- Météo ancienne ou absente : l'heure des données, rien qui rassure. -->
    <vw-list-row data-test="band-weather" [size]="64" [dense]="true" tone="stale" [thumbSize]="26"
      [title]="'home.band.weather.stale' | translate"
      [subtitle]="!stale ? '' : (staleToday ? 'home.band.weather.stale-at-today' : 'home.band.weather.stale-at') | translate: { day: (stale | vwDate: 'weekday'), time: (stale | vwDate: 'hour') }"
      (rowClick)="openWeather.emit()">
      <vw-clock-icon vwListRowIcon class="h-[18px] w-[18px]"></vw-clock-icon>
    </vw-list-row>
  } @else if (weather) {
    <!-- Texte agrandi : les 3 jours passent sous « Gel cette nuit » plutôt que de le casser sur trois lignes. -->
    <!-- Le pictogramme et le ton du jour annoncé : soleil demain, pluie mercredi en bleu, comme le gel. -->
    <vw-list-row data-test="band-weather" [size]="64" [dense]="true" thumb="bare" [trailingWraps]="true" [tone]="nextTone"
      [title]="next ? (next.key | translate: { day: (next.date | vwDate: 'weekday') }) : ''"
      [subtitle]="night === null || weather.today.max === null ? '' : ('home.band.weather.temps' | translate: { min: (round(night) | vwNumber: 0), max: (round(weather.today.max) | vwNumber: 0) })"
      (rowClick)="openWeather.emit()">
      <img vwListRowIcon [src]="next?.icon ?? weather.today.icon" alt="" class="h-6 w-6" />
      @if (nextDays.length) {
        <vw-forecast-mini vwListRowTrailing [days]="nextDays"></vw-forecast-mini>
      }
    </vw-list-row>
  }
  @if (moon && moonGroup) {
    <!-- La phase se lit aussi dans le dessin : partie éclairée en or doux, ombre en gris du thème. -->
    <vw-list-row data-test="band-moon" [size]="52" [dense]="true" thumb="bare"
      [title]="(moon.influence ? 'home.lunar.influence.' + moon.influence : 'home.band.moon.phase.' + moonGroup) | translate"
      [subtitle]="(moon.influence
        ? (moon.path ? 'home.band.moon.line.' + moonGroup + '.' + moon.path : 'home.band.moon.phase.' + moonGroup)
        : (moon.path ? 'home.lunar.moonPath.' + moon.path : '')) | translate"
      (rowClick)="openMoon.emit()">
      <svg vwListRowIcon class="h-6 w-6" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10.5" class="fill-vw-line" />
        @if (moonLit) {
          <path [attr.d]="moonLit" class="fill-vw-premium-line" />
        }
      </svg>
    </vw-list-row>
  }
</vw-list-section>
